import React, { useState, useEffect, useRef } from 'react'
import { playableUrl } from '../../utils/playableUrl';
import { reloadIfLinksExpired } from '../../utils/expiredLinks';
import { newShareLink } from '../../utils/shareLink';
import DownloadRequestFormModal from '../../components/DownloadRequestFormModal';
import DownloadSelectionBar from '../../components/DownloadSelectionBar';
import { runDownloadRequestSubmit } from '../../utils/runDownloadRequestSubmit';
import { canDownloadDirectly } from '../../utils/downloadAccess';
import { MSG } from "../../constants/toastMessages";
import CardVideoPlayer from '../../components/CardVideoPlayer';
import { HiDownload } from "react-icons/hi";
import { GoPlus } from "react-icons/go";
import { RiDeleteBinLine } from "react-icons/ri";
import { FiEdit2, FiLink, FiMail } from "react-icons/fi";
import { toast } from 'react-toastify';
import MediaPreview from '../../components/MediaPreview';
import LargeBundleNote from '../../components/LargeBundleNote';
import { apiCallingPost, prepareDownload } from '../../api/services';
import useDownloadLock from '../../hooks/useDownloadLock';
import startBrowserDownload from '../../utils/startBrowserDownload';
import { MdOutlineZoomOutMap, MdOutlinePlayCircle, MdTune, MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import ListReject from './list-reject';
import ListUpload from './list-upload';
import Loader from "../../assets/images/loader.gif"
import { IoShareSocialOutline } from "react-icons/io5";
import { useSelector, useDispatch, useStore } from "react-redux";
import { setSelectedQuality, setCurrentPlaybackRate, setViewType, setVolume, setIsMuted } from '../../redux/reducers/commonSliceWhiteList';
import { toggleRow, removeVideo, clearSelection, selectSelectedItems, selectSelectedVideoIds, selectSelectedVideos } from '../../redux/reducers/selectionSlice';
import { IoSettingsSharp, IoLocationOutline } from "react-icons/io5";
import { MdOutlinePermMedia } from "react-icons/md";
import { GrMultimedia } from "react-icons/gr";
import { CiCalendarDate } from "react-icons/ci";
import { IoIosResize } from "react-icons/io";
import { debounce } from 'lodash';
import moment from 'moment';
import { IoCloseOutline } from "react-icons/io5";
import { FaDownload, FaEye } from "react-icons/fa";
import { RiLoader4Fill } from "react-icons/ri";
import { MdPictureInPicture, MdCloseFullscreen } from "react-icons/md";
import { BiDownload, BiFile } from "react-icons/bi";
import axios from "axios";
// import Pagination from "react-js-pagination"; // Previous pagination - kept for future reference

let url

const PAGE_BLOCK_SIZE = 3;

function List(props) {
  const dispatch = useDispatch();
  const store = useStore();
  const { selectedQuality, currentPlaybackRate, speeds, viewType, volume, isMuted } = useSelector((state) => state.commonDataWhiteList);
  const videoRefs = useRef({});
  const listTopRef = useRef(null);
  const shareIconsRef = useRef(null);
  const [tagPopupFlag, setTagPopupFlag] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [popupList, setPopupList] = useState(false);
  const [popupShareStates, setPopupShareStates] = useState({});
  const [popupReject, setPopupReject] = useState(false);
  const [rejectData, setRejectData] = useState([]);
  const [mode, setMode] = useState("");
  const [selectIndex, setSelectIndex] = useState("");
  const [speedFlag, setSpeedFlag] = useState(true);
  const [selectData, setSelectData] = useState([]);
  const [hoveredVideoId, setHoveredVideoId] = useState(null);
  const dropdownRef = useRef(null);
  const [activeSettings, setActiveSettings] = useState(null);
  const [quality, setQuality] = useState(true);
  const popupRef = useRef(null);
  const popupRefList = useRef(null);
  const [activeShareIndex, setActiveShareIndex] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [isShareLink, setIsShareLink] = useState(false)
  const [shareMode, setShareMode] = useState("Viewer")
  const [isDownload, setIsDownload] = useState(false)
  const [isOriginalCheck, setIsOriginalCheck] = useState(false);
  const [isMp4Check, setIsMp4check] = useState(false)
  const [shareRecipientEmail, setShareRecipientEmail] = useState("")
  const [shareMessage, setShareMessage] = useState("")
  // The files the bulk download modal shows/downloads (the approved subset of
  // the selection, or all of it) — separate from the selection itself.
  const [downloadSet, setDownloadSet] = useState([]);
  const [pipVideoId, setPipVideoId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [videoIDsIndividual, setVideoIDsIndividual] = useState([]);
  const [isMultipleDownload, setIsMultipleDownload] = useState(false);
  // staff / full access download outright; everyone else requests (see downloadAccess.js)
  const canDownloadDirect = canDownloadDirectly(props.userData);
  // #9: when set, the mandatory download-request form modal is open. { count, submit }.
  // submit(details) performs the actual saveVideoDownloadRequest POST.
  const [downloadRequestForm, setDownloadRequestForm] = useState(null);
  const [selectedQualities, setSelectedQualities] = useState({});
  const [totalFileSize, setTotalFileSize] = useState(0)
  const [totalFileSizeMb, setTotalFileSizeMb] = useState(0)
  const [isDownloadBtn, setIsDownloadBtn] = useState(false)
  const [isVideoFormatSelect, setIsVideoFormatSelect] = useState(true)
  // The selection lives in the store (selectionSlice) — shared with View All
  // and kept across searches and this component remounting.
  const selectedItems = useSelector(selectSelectedItems);
  const selectedVideoIds = useSelector(selectSelectedVideoIds);
  const selectedDownloadVideoALL = useSelector(selectSelectedVideos);
  const [hasVideo, setHasVideo] = useState(false);
  const [isDelete, setIsDelete] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState(null);
  const [individualDownloadVideo, setIndividualDownloadVideo] = useState([]);
  const [isSingleDownload, setIsSingleDownload] = useState(true)
  const [saveFlag, setSaveFlag] = useState(false);
  const [pageBlockStart, setPageBlockStart] = useState(1);

  // Pagination: use props from Home (cursor-based)
  const activePage = props.activePage ?? 1;
  const totalPages = Math.ceil(Number(props.destListTCount) / Number(props.itemsCountPerPage)) || 1;
  const hasNextPage = totalPages > 0 && activePage < totalPages;
  const hasPreviousPage = activePage > 1;

  // Pagination lives at the list bottom — without this, a page change leaves
  // the viewport parked at the bottom of the NEW page's results.
  const scrollToListTop = () => {
    listTopRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const goToFirstPage = () => {
    if (!hasPreviousPage) return;
    setPageBlockStart(1);
    props.getData({ direction: "first", cursorId: null });
    scrollToListTop();
  };
  const goToPrevBlock = () => {
    if (!hasPreviousPage || props.firstId == null) return;
    const prevPage = activePage - 1;
    if (prevPage < pageBlockStart) {
      setPageBlockStart(Math.max(pageBlockStart - PAGE_BLOCK_SIZE, 1));
    }
    props.getData({ direction: "previous", cursorId: props.firstId });
    scrollToListTop();
  };
  const goToNextBlock = () => {
    if (!hasNextPage || props.lastId == null) return;
    const nextPage = activePage + 1;
    if (nextPage >= pageBlockStart + PAGE_BLOCK_SIZE) {
      setPageBlockStart(pageBlockStart + PAGE_BLOCK_SIZE);
    }
    props.getData({ direction: "next", cursorId: props.lastId });
    scrollToListTop();
  };
  const goToLastPage = () => {
    if (!hasNextPage) return;
    props.getData({ direction: "last", cursorId: null });
    scrollToListTop();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close share list popup
      if (popupRefList.current && !popupRefList.current.contains(event.target)) {
        setActiveShareIndex(null);
      }

      // Close share icons popup
      if (shareIconsRef.current && !shareIconsRef.current.contains(event.target)) {
        setPopupShareStates({});
      }

      // Close video settings popups
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setActiveSettings(null);
        setSpeedFlag(true);
        setQuality(true);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleVideoQualityChange = (videoId, selectedQuality, sizes) => {
    const selectedVideoSize = sizes.find(q => q.qualitytype === selectedQuality)?.qualityvideosize || 0;

    setSelectedQualities(prev => {
      const updated = {
        ...prev,
        [videoId]: { quality: selectedQuality, size: selectedVideoSize }
      };
      // Update total size
      const totalSizeMB = downloadSet.reduce((sum, video) => {
        const selected = updated[video.video_id];
        return sum + (selected?.size ? Number(selected.size) : Number(video.size.split(' ')[0]));
      }, 0);
      const formattedSize = getTotalSizeMB(totalSizeMB.toFixed(2));
      setTotalFileSize(formattedSize);
      setTotalFileSizeMb(totalSizeMB);
      return updated;
    });
  };


  const handleQualityChange = (quality) => {
    dispatch(setSelectedQuality(quality));
    setActiveSettings(false);
  };

  const toggleSettings = (videoId) => {
    setActiveSettings(activeSettings == videoId ? null : videoId);
    setHoveredVideoId(null);
    setSpeedFlag(true);
    setQuality(true);
  };

  const popupTagShow = (data) => {
    setSelectedData(data);
    setTagPopupFlag(true);
    document.body.style.overflow = 'hidden';
  };

  const approveList = async (data) => {
    let postData = {
      videoId: [data.video_id],
      userId: props?.userData?.userId
    };
    try {
      const { data: responseData } = await apiCallingPost("api/video/approveVideo", postData);
      if (responseData.success === "1") {
        toast.success(MSG.mediaApproved);
        setTimeout(() => {
          props.getData({ direction: "first", cursorId: null });
        }, 1000);
      } else {
        toast.error(MSG.genericError);
      }
    } catch (error) {
      console.error("Error Approved Video:", error);
    }
  };

  const deleteList = async (data) => {
    // if (window.confirm("Do you want to delete?")) {
    if (!selectedToDelete) return;
    setSaveFlag(true)
    let postData = {
      videoIds: [selectedToDelete.video_id],
      userId: props.userData.userId
    };
    try {
      const { data: responseData } = await apiCallingPost("api/video/deleteVideo", postData);
      if (responseData.success === "1") {
        toast.success(MSG.mediaDeleted);
        setTimeout(() => {
          props.getData({ direction: "first", cursorId: null });
          setSaveFlag(false)
        }, 1000);
      } else {
        toast.error(MSG.genericError);
      }
    } catch (error) {
      console.error("Error Deleting Video:", error);
    }
    deletePopupCancel();
    // }
  };

  // Toolbar action (project-based requests, 2026-09-23). Two branches and no
  // per-asset triage: cards carry no request status any more (one file can sit
  // in several requests), so the whole selection is either downloaded outright
  // — staff / full access, the same rule as the server's downloadAuth — or
  // requested as ONE new request under a project. Requesting a file that is
  // already pending or approved elsewhere is allowed: that is another project.
  const downloadMultiple = () => {
    if (canDownloadDirect) {
      // a fresh array: the selector's reference is stable, and the modal's size
      // total must recompute on every open (the Single modal overwrites it)
      setDownloadSet([...selectedDownloadVideoALL]);
      setIsMultipleDownload(true);
      return;
    }
    const videoIds = selectedDownloadVideoALL.map((v) => v.video_id);
    setDownloadRequestForm({
      count: videoIds.length,
      // Failures rethrow so the form modal stays open with the user's input
      // (retry or cancel), and always get a toast. Requester and timestamp
      // come from the server's session and clock, not from here.
      submit: async (details) => {
        const postData = { video_id: videoIds, ...details };
        let responseData;
        try {
          ({ data: responseData } = await apiCallingPost("api/video/saveVideoDownloadRequest", postData));
        } catch (error) {
          console.error("Error submitting download request:", error);
          toast.error(MSG.requestFailed);
          throw error;
        }
        if (responseData.success !== "1") {
          toast.error(MSG.requestFailed);
          throw new Error("saveVideoDownloadRequest failed");
        }
        toast.success(MSG.downloadRequestSubmitted);
        return responseData;
      },
      clearSelection: true,
    });
  };
  const getTotalSizeInMB = (videoArray) => {
    let totalSize = 0;
    videoArray.forEach(video => {
      let sizeInMB;
      if (video.download_original || video.download_original === "" || canDownloadDirect) {
        // Use original size from `videoObj.size`
        sizeInMB = parseFloat(video.size);
        setSelectedQualities(prev => {
          const updated = {
            ...prev,
            [video.video_id]: { quality: "Download Original", size: sizeInMB }
          };
          return updated;
        });
      } else if (Array.isArray(video.qualityvariants) && video.qualityvariants.length > 0) {

        // Use the first quality variant size
        sizeInMB = parseFloat(video.qualityvariants[0].qualityvideosize);
        setSelectedQualities(prev => {
          const updated = {
            ...prev,
            [video.video_id]: { quality: video.qualityvariants[0].qualitytype, size: sizeInMB }
          };
          return updated;
        });
      } else {
        sizeInMB = 0; // fallback
      }
      const sizeString = sizeInMB.toString().trim().toUpperCase(); // Ensure "MB"
      const value = parseFloat(sizeString.replace("MB", ""));
      totalSize += isNaN(value) ? 0 : value;
    });
    return totalSize.toFixed(2); // Round to 2 decimals
  };
  const { isLocked, runLocked } = useDownloadLock();
  const handleDownloadAll = () => runLocked('all', async () => {
    try {
      const selectedResolutionArray = getSelectedQualityArray();
      const { responseData } = await prepareDownload(selectedResolutionArray, null);
      startBrowserDownload(responseData, "video.zip");
      toast.success(MSG.downloadStarted);
    } catch (err) {
      toast.error(MSG.downloadFailed);
    }
  });
  const getSelectedQualityArray = () => {
    return downloadSet.map((video) => {
      const selected = selectedQualities[video.video_id];
      return {
        fileId: video.video_id,
        type: selected?.quality === "Download Original" || !selected?.quality ? "" : selected.quality,
      };
    });
  };
  const handleSingleDownload = (video, selectedQualityObj) => runLocked(video.video_id, async () => {
    const resolutionType = selectedQualityObj?.quality === "Download Original" || !selectedQualityObj?.quality
      ? ""
      : selectedQualityObj.quality;
    const requestPayload = [{
      fileId: video.video_id,
      type: resolutionType
    }];
    try {
      const { responseData } = await prepareDownload(requestPayload, null);
      startBrowserDownload(responseData, `${video.fileName}.${video.file_extension}`);
      toast.success(MSG.downloadStarted);
    } catch (err) {
      console.error("Single download failed", err);
      toast.error(MSG.downloadFailed);
    }
  });

  const listPopup = (data, mode, index) => {
    setPopupList(true);
    setMode(mode);
    setSelectIndex(index);
    setSelectData(data);
    document.body.style.overflow = 'hidden';
  };

  const listSharePopup = async (ids, mode, list, index) => {
    const heading = list?.video_heading || '';
    const description = list?.description || '';
    let body = '';

    if (index !== undefined) {
      body = `Hi,

     ${heading}

      ${description ? `Description: ${description}\n\n` : ''}
      View it here: ${url}

      Best regards,
      Qatar`;
    } else {
      body = `Hi,
      View it here: ${url}

      Best regards,
      Qatar`;
    }

    const encodedBody = encodeURIComponent(body);
    shareMedia(ids, url, mode, heading, encodedBody, index)
  };

  const shareMedia = async (ids, url, mode, heading, encodedBody, index) => {
    let postData = {
      videoId: ids,
      encodedVideoUrl: url,
      mode: shareMode,
      downloadOriginal: isOriginalCheck,
      downloadMp4: isMp4Check,
      ...(mode === 'mail' && shareRecipientEmail && {
        shareType: 'mail',
        recipientEmail: shareRecipientEmail,
        message: shareMessage
      })
    };

    try {
      const { data: responseData } = await apiCallingPost("api/video/saveShareRequest", postData);

      if (responseData.success === "1") {
        if (mode === 'mail') {
          toast.success(MSG.shareEmailSent);
          cancelPopup();
        }
        if (index !== undefined) {
          setPopupShareStates((prevStates) => ({
            ...prevStates,
            [index]: !prevStates[index],
          }));
        }
      } else {
        toast.error(MSG.genericError);
      }
    } catch (error) {
      // A refused or failed save means the copied/sent link will not open: say so.
      console.error("Error saving share:", error);
      toast.error(MSG.genericError);
    }
  }
  const linkCopy = (ids, mode, list, index) => {

    if (!isOriginalCheck && !isMp4Check && isDownload && hasVideo) {
      setIsVideoFormatSelect(false)
      document.getElementById("originalVedioCheck")
      return;
    } else {
      if (isDownload) {
        setIsVideoFormatSelect(true)
      }
      setShareMode("Viewer")
      let videoIds = (videoIDsIndividual.length > 0 ? videoIDsIndividual : ids)

      shareMedia(videoIds, url, mode)
      const shareElement = document.getElementById("link-copy-common");
      if (shareElement && isVideoFormatSelect) {
        shareElement.classList.toggle("d-none");
        setTimeout(() => {
          shareElement.classList.toggle("d-none")
          cancelPopup()
        }
          , 1500);
      }
      navigator.clipboard.writeText(url)
        .then(() => {
          // setCopiedIndex(list.video_id);
          setTimeout(() => {
            setCopiedIndex(null)
            // setSelectedItems([]);
          }
            , 1500);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }

  };

  // After the selection shrinks: the share flow's "has a video" flag follows
  // the selection (a single-file share sets it on its own), and the share
  // panel closes.
  const afterDeselect = () => {
    setHasVideo(selectSelectedItems(store.getState()).some(item => item.type_flag === 2));
    const shareElement = document.getElementById("share-common");
    if (shareElement) {
      shareElement.classList.add("d-none");
    }
  };
  const removeFromSelection = (videoId) => {
    dispatch(removeVideo(videoId));
    afterDeselect();
  };
  // Browse cards are one row per video: ticking selects the video, unticking
  // drops every row of it (View All may have selected it as segments).
  const handleCheckboxChange = (e, videoId, fileTypeId, videoObj) => {
    setVideoIDsIndividual([])
    if (e.target.checked) {
      dispatch(toggleRow({ videoId, typeFlag: fileTypeId, row: videoObj, checked: true }));
      setHasVideo(selectSelectedItems(store.getState()).some(item => item.type_flag === 2));
    } else {
      removeFromSelection(videoId);
    }
  };


  const rejectPopup = (data) => {
    setRejectData(data);
    setPopupReject(true);
    document.body.style.overflow = 'hidden';
  };

  const cancelPopup = () => {
    setPopupList(false);
    setPopupReject(false);
    setTagPopupFlag(false);
    setIsShareLink(false);
    setIsDownload(false)
    setIsMp4check(false);
    setIsOriginalCheck(false)
    setIsVideoFormatSelect(true)
    setShareRecipientEmail("")
    setShareMessage("")
    document.body.style.overflow = 'auto';
    //setSelectedItems([]);
    setVideoIDsIndividual([])
  };

  const handleMouseEnter = (data) => {
    setHoveredVideoId(data.video_id);
  };

  const handleMouseLeave = (videoId) => {
    setHoveredVideoId(null);
    setActiveSettings(null);
    setSpeedFlag(true);
    setQuality(true);
  };

  const handlePlaybackRateChange = (rate) => {
    dispatch(setCurrentPlaybackRate(rate));
    setActiveSettings(false);
  };

  const showSpeed = () => {
    setSpeedFlag(!speedFlag);
  };

  const backToList = () => {
    setSpeedFlag(true);
  };

  const showQuality = () => {
    setQuality(!quality);
  };

  const backToQuality = () => {
    setQuality(true);
  };

  const handleVolumeChange = (e) => {
    dispatch(setVolume(e.target.volume));
    dispatch(setIsMuted(e.target.muted));
  };
  const handlePiP = async (videoId) => {
    const playerInstance = videoRefs.current[videoId];
    const videoElement = playerInstance?.getVideoElement();
    if (!videoElement) return;

    if (!document.pictureInPictureElement) {
      try {
        await videoElement.requestPictureInPicture();
        setPipVideoId(videoId);
      } catch (error) {
        console.error('Failed to enter PiP:', error);
      }
    } else {
      try {
        await document.exitPictureInPicture();
        setPipVideoId(null);
      } catch (error) {
        console.error('Failed to exit PiP:', error);
      }
    }
  };
  const getTotalSizeMB = (mb) => {
    if (mb >= 1024 * 1024) return `${(mb / (1024 * 1024)).toFixed(2)} TB`;
    if (mb >= 1024) return `${(mb / 1024).toFixed(2)} GB`;
    return `${mb} MB`;
  };
  // Clear BOTH selection families (the checkbox feeds share/edit AND download
  // sets), so every checkbox unchecks and the bar disappears.
  const isStaff = ['Admin', 'Super_admin', 'APPROVER'].includes(props.userData?.roleDisplayName);
  // Share the whole selection (selection bar). Only staff can create shares.
  const shareSelection = () => {
    setVideoIDsIndividual([]);
    url = newShareLink();
    setIsShareLink(true);
    setHasVideo(selectedItems.some(item => item.type_flag === 2));
  };
  const clearDownloadSelection = () => {
    dispatch(clearSelection());
    setVideoIDsIndividual([]);
    setHasVideo(false);
    const shareElement = document.getElementById("share-common");
    if (shareElement) {
      shareElement.classList.add("d-none");
    }
  };
  const cancelpopup = () => {
    setIsMultipleDownload(false)
    setSelectedQualities({})
    setIsDownloadBtn(false)
    setIsVideoFormatSelect(true)
    setShareMode("Viewer")
  }

  useEffect(() => {
    const shareElement = document.getElementById("link-copy-common");
    if (shareElement && isVideoFormatSelect) {
      shareElement.classList.toggle("d-none");
      setTimeout(() => {
        shareElement.classList.toggle("d-none")
        cancelPopup()
      }
        , 1500);
    }
  }, [isVideoFormatSelect]);

  useEffect(() => {
    const total = getTotalSizeInMB(downloadSet);
    const formattedSize = getTotalSizeMB(total);
    setTotalFileSize(formattedSize)
    setTotalFileSizeMb(Number(total))
  }, [downloadSet]);

  const deletePopupCancel = () => {
    setIsDelete(false)
    setSelectedToDelete(null);
  }
  return (
    <div className="list-wrapper my-5" ref={listTopRef}>

      <div className='container'>
        <div className="row align-items-center">
          <div className='col-md-12 col-lg-4 col-12'>
            <h2 className='main-head'>Moments in Motion</h2>
          </div>
          <div className='col-md-12 text-end col-lg-8 col-12'>
            <div className="row">
              <div className="col-lg-12 filter-section">
                {(selectedDownloadVideoALL.length > 0) &&
                  <button className="btn-listing-btn" onClick={() => downloadMultiple()}
                  // onClick={() => downloadAll()}
                  >
                    {/* {isLoading ?
                      (<RiLoader4Fill className="loader-icon" />) : */}
                    <HiDownload />
                    {/* } */}
                  </button>}
                {((selectedVideoIds.length > 0 || videoIDsIndividual.length > 0)) && (
                  <>
                    {isShareLink &&
                      <div className="modal-admin-wrapper multiple-upload" >
                        <div className="modal-ad-popup modal-md">
                          <span className="closeBtn closeBtn_file">
                            <IoCloseOutline onClick={() => cancelPopup()} size={32} />
                          </span>
                          <div className="modal-innerpopup">

                            <div className="row mb-3">
                              <div className='col-lg-8 col-6'>
                                <h5 className="modal-head mb-0 text-start mt-2">Anyone with the link</h5>
                              </div>
                              <div className='col-lg-4 col-6 '>
                                <select name="" id="" className='form-control form-select-drop' onChange={(e) => {
                                  setShareMode(e.target.value)
                                  if (e.target.value === "Download") {
                                    setIsDownload(true)
                                  } else {
                                    setIsDownload(false)
                                  }
                                }} >
                                  <option value="Viewer" selected >View only</option>
                                  <option value="Download">Download</option>
                                </select>
                                {/* {isDownload && */}

                                <div style={{ visibility: isDownload && hasVideo ? 'visible' : 'hidden' }}>
                                  <div className="checkbox-wrapper-1 checkbox-list-select d-flex align-items-center gap-3 mt-2">
                                    <div className='d-flex align-items-center gap-1'>
                                      <input id={`originalVedioCheck`} className="substituted" type="checkbox" aria-hidden="true"
                                        checked={isOriginalCheck}
                                        onChange={(e) => setIsOriginalCheck(e.target.checked)}
                                      />
                                      <label className=" d-flex align-items-center" htmlFor={`originalVedioCheck`}
                                        style={{ fontSize: '12px' }}
                                      >Original</label>
                                    </div>
                                    <div className='d-flex align-items-center gap-1'>
                                      <input id={`mp4Check`} className="substituted" type="checkbox" aria-hidden="true"
                                        checked={isMp4Check}
                                        onChange={(e) => setIsMp4check(e.target.checked)}
                                      />
                                      <label className=" d-flex align-items-center" htmlFor={`mp4Check`}
                                        style={{ fontSize: '12px' }}
                                      >MP4</label>
                                    </div>
                                  </div>
                                  {!isVideoFormatSelect && (<div className='col-lg-8 col-6 d-flex align-items-center'>
                                    <h6 className="modal-head mb-0 text-start" style={{ fontSize: '12px', whiteSpace: 'nowrap', color: 'red', fontWeight: 'normal' }}>Please select Video format</h6>
                                  </div>)}
                                </div>

                              </div>

                            </div>


                            <div className="mb-3">
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Recipient email address"
                                value={shareRecipientEmail}
                                onChange={(e) => setShareRecipientEmail(e.target.value)}
                              />
                              <textarea
                                className="form-control mt-2"
                                rows={2}
                                placeholder="Add a message (optional)"
                                value={shareMessage}
                                onChange={(e) => setShareMessage(e.target.value)}
                              />
                            </div>

                            <div className='d-flex align-items-center gap-2'>
                              <button className="addButton add-index addButtonShare link-btns  mx-0 d-flex align-items-center gap-2"
                                style={{ top: 'unset' }}
                                onClick={() => linkCopy(selectedVideoIds, "copy")}
                              >
                                <FiLink size={17} />Copy link
                                <div
                                  className="d-none position-absolute ms-0 mt-5 px-2 py-1 text-white bg-dark rounded"
                                  id="link-copy-common" style={{ fontSize: "10px", zIndex: 10, width: "53px" }}
                                >
                                  Copied!
                                </div>
                              </button>
                              <button
                                className="addButton add-index addButtonShare link-btns mx-0 d-flex align-items-center gap-2"
                                style={{ top: 'unset' }}
                                disabled={!shareRecipientEmail}
                                onClick={() => {
                                  if (shareRecipientEmail) listSharePopup(videoIDsIndividual.length > 0 ? videoIDsIndividual : selectedVideoIds, "mail");
                                }}
                              >
                                <FiMail size={17} />Share by Email
                              </button>
                            </div>

                          </div>
                        </div>
                      </div>}

                  </>
                )}
                {downloadRequestForm &&
                  <DownloadRequestFormModal
                    open={true}
                    count={downloadRequestForm.count}
                    onCancel={() => { setDownloadRequestForm(null); downloadRequestForm.onCancel?.(); }}
                    onSubmit={(details) => runDownloadRequestSubmit(downloadRequestForm, details, {
              close: () => setDownloadRequestForm(null),
              clearSelection: clearDownloadSelection,
              onAfterSubmitError: (e) => console.error("Refresh after download request failed:", e),
            })}
                  />}

                <DownloadSelectionBar
                  count={selectedDownloadVideoALL.length}
                  items={selectedDownloadVideoALL.map((v) => ({ key: v.video_id, name: v.fileName }))}
                  onRemove={removeFromSelection}
                  mode={canDownloadDirect ? "download" : "request"}
                  onDownload={downloadMultiple}
                  onShare={isStaff ? shareSelection : undefined}
                  onClear={clearDownloadSelection}
                />

                {isMultipleDownload &&
                  <div className="modal-admin-wrapper" >
                    <div className="modal-ad-popup modal-md">
                      <div className="modal-innerpopup ">
                        <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span>
                        <div className="modal-headdiv d-flex justify-content-between">
                          <h5 className="modal-head">Download Files!</h5>
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <div className="d-flex align-items-center gap-2"> <BiFile /><strong> {downloadSet.length} file(s), {totalFileSize} </strong></div>
                          </div>
                          <LargeBundleNote totalMb={totalFileSizeMb} />
                        </div>
                        <div className="modal-admin-body my-3" style={{ maxHeight: 'calc(100vh - 290px)' }}>
                          <div className="table-responsive">

                            <table className="table table-bordered admin-list-table">
                              <tbody>
                                {downloadSet.map((data, i) => {

                                  return (
                                    < tr key={i} >
                                      <td style={{ width: '40%', minWidth: '250px' }} className='text-start'>{data.video_heading}{"." + data.file_extension}</td>
                                      <td style={{ width: '20%', minWidth: '100px' }} className='text-center'>
                                        {selectedQualities[data.video_id]?.size
                                          ? `${selectedQualities[data.video_id].size} MB`
                                          : (data.download_mp4 && !data.download_original) ? `${data.qualityTypeArray[0].qualityvideosize} MB` : `${data.size} MB`} </td>

                                      <td style={{ width: '40%', minWidth: '250px' }} className='text-center'>
                                        {props.userData.roleDisplayName === "User" &&
                                          // (data.downloadStatus === "APPROVED" ?
                                          <div className="d-flex align-items-center gap-3"
                                            style={{ color: '#00627B' }}
                                          >
                                            <select name="" id="" className='form-control form-select-drop'
                                              value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                              onChange={(e) =>
                                                handleVideoQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                              }
                                            >
                                              {(data.download_original || canDownloadDirect) &&
                                                <option value="Download Original" >Download Original</option>}
                                              {(data.download_mp4 || canDownloadDirect) &&
                                                data.qualityTypeArray
                                                  ?.filter(
                                                    (obj) => (
                                                      (
                                                        obj.qualitytype !== "" &&
                                                        obj.qualitytype !== "unknown" && obj.qualitytype !== "undefined")
                                                    ))
                                                  .map((obj, j) => (
                                                    <option key={j} value={obj.qualitytype}>
                                                      {obj.qualitytype}
                                                    </option>
                                                  ))}
                                              {/* data.qualityTypeArray?.map((obj, j) => 
                                                   {(obj.qualitytype && obj.qualitytype !== "" && obj.qualitytype !== "unknown" && obj.qualitytype !== "undefined") &&
                                                   <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>}
                                                 )}     */}
                                            </select>

                                            <span

                                              style={{ flex: 'none', opacity: isLocked(data.video_id) ? 0.5 : 1, cursor: isLocked(data.video_id) ? 'default' : 'pointer' }}

                                              onClick={() => !isLocked(data.video_id) && handleSingleDownload(data, selectedQualities[data.video_id])}>

                                              {isLocked(data.video_id)

                                                ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />

                                                : <FaDownload />}</span>
                                          </div>
                                          // : "Waiting for Approval")
                                        }
                                        {['Admin', 'Super_admin', 'APPROVER'].includes((props.userData?.roleDisplayName)) &&

                                          <div className="d-flex align-items-center gap-3"
                                            style={{ color: '#00627B' }}
                                          >
                                            <select name="" id="" className='form-control form-select-drop'
                                              value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                              onChange={(e) =>
                                                handleVideoQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                              }
                                            >

                                              <option value="Download Original" >Download Original</option>
                                              {
                                                data.qualityTypeArray
                                                  ?.filter(
                                                    (obj) => (
                                                      (
                                                        obj.qualitytype !== "" &&
                                                        obj.qualitytype !== "unknown" && obj.qualitytype !== "undefined")
                                                    ))
                                                  .map((obj, j) => (
                                                    <option key={j} value={obj.qualitytype}>
                                                      {obj.qualitytype}
                                                    </option>
                                                  ))
                                                // <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>
                                              }
                                            </select>

                                            <span

                                              style={{ flex: 'none', opacity: isLocked(data.video_id) ? 0.5 : 1, cursor: isLocked(data.video_id) ? 'default' : 'pointer' }}

                                              onClick={() => !isLocked(data.video_id) && handleSingleDownload(data, selectedQualities[data.video_id])}>

                                              {isLocked(data.video_id)

                                                ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />

                                                : <FaDownload />}</span>
                                          </div>

                                        }
                                      </td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="tag-popup-footer">
                          {!isDownloadBtn &&
                            <div className="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                className="accept-all-btn w-100 py-2 accept-all-gray"
                                onClick={() => cancelpopup()}
                              >
                                Cancel
                              </button>

                              <button
                                type="button"
                                className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                                onClick={() => handleDownloadAll()}
                                disabled={isLocked('all')}
                              >
                                {isLocked('all')
                                  ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> Starting…</>
                                  : <>Download all <BiDownload className="ms-0" /></>}
                              </button>
                            </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {isDelete &&
                  <div className="modal-admin-wrapper multiple-upload" >
                    <div className="modal-ad-popup modal-md">
                      <div className="modal-innerpopup ">
                        <div className="modal-headdiv d-flex justify-content-between">
                          <h5 className="modal-head w-100 text-center">Do you want to delete?</h5>
                          {/* <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span> */}
                        </div>
                      </div>
                      <div className="tag-popup-footer">
                        <div className="d-flex align-items-center gap-2">
                          <button
                            type="button"
                            className="accept-all-btn w-100 py-2 accept-all-gray"
                            onClick={() => deletePopupCancel()}
                          >
                            Cancel
                          </button>

                          <button
                            type="button"
                            disabled={saveFlag}
                            className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                            onClick={() => deleteList()}
                          >
                            Ok
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>}
                <div className='list-grid-btns'>
                  {props.destinationList.length > 0 && (
                    <>
                      <div
                        className={`list-grid-div ${viewType === 'grid' ? 'active' : ''}`}
                        onClick={() => dispatch(setViewType('grid'))}
                      >
                        <div className='grid-fill'>
                          <div className='grid-inner-fill'>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                          </div>
                          <div className='grid-inner-fill'>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                          </div>
                          <div className='grid-inner-fill'>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`list-grid-div ${viewType === 'list' ? 'active' : ''}`}
                        onClick={() => dispatch(setViewType('list'))}
                      >
                        <div className='list-bar'>
                          <div className='inner-list-bar'></div>
                          <div className='inner-list-bar'></div>
                          <div className='inner-list-bar'></div>
                        </div>
                      </div>
                    </>
                  )}
                  {(props.isAuthenticated && ['Admin', 'Super_admin', 'APPROVER'].includes((props.userData?.roleDisplayName))) &&
                    <button className="addButton add-index ms-3" onClick={() => listPopup("", "Add", "")}>
                      <GoPlus /> Add
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='position-relative'>
          <div className={`list  row g-4 ${viewType === 'grid' ? 'row-cols-1 row-cols-md-2 row-cols-lg-3' : 'row-cols-1 list-view-div col-xl-11'}`}>
            {props.destinationList.map((list, index) => (
              <div className="list-sub col" key={list.video_id} id={list.video_id}>
                {(props.isAuthenticated && (props.userData?.roleDisplayName !== "User")) &&
                  <div className='reject-sec-wrap'>
                    {((props.userData?.roleDisplayName === "Super_admin" || props.userData?.roleDisplayName === "APPROVER") && list.isApproved == 0 && list.approveStatus === "Open") &&
                      <div className='reject-sec'>
                        <button className="approveBtn"
                          id={`approveBtn` + index}
                          onClick={() => approveList(list)}>Approve</button>
                        <button className="rejectBtn" onClick={() => rejectPopup(list)}>Reject</button>
                      </div>
                    }
                    {/* Every staff role (this block is staff-only): a rejected file now stays in the
                        library (reject keeps files, 2026-10-27), so the reviewer needs the label too. */}
                    {((list.isApproved == 0) && (list.approveStatus === "Rejected")) &&
                      <div className='reject-sec'>
                        <span
                          className={`text-start w-100 reject-white ${viewType === 'list' ? 'reject-text' : ' '}`}
                        >Rejected: {list.rejected_reason}</span>
                      </div>
                    }
                  </div>
                }
                <div className='position-relative'>
                  <div className={`card ${viewType === 'grid' ? '' : 'list-view'}`}
                  >
                    <div className='position-relative loader-image-div'

                      onMouseEnter={() => {
                        handleMouseEnter(list)
                      }}
                      onMouseLeave={() => {
                        handleMouseLeave(list.video_id)
                      }}>


                      {list.fileTypeId == "1" ?
                        <div className="position-relative image-container">
                          <img src={(list?.thumbnail_image) ? list.thumbnail_image : list.url} className="card-img-top card-video-img media-no-save" draggable={false} alt="..."
                            style={{ backgroundColor: "#f1f1f1" }}
                            onContextMenu={(event) => event.preventDefault()}
                            onClick={() => {
                              popupTagShow(list)
                            }}
                            onError={(e) => { if (reloadIfLinksExpired(e.target.src)) return; e.target.onerror = null; if (list.url) e.target.src = list.url; }} // expired link → reload; else one fallback, then stop
                          />
                          <MdOutlineZoomOutMap className='img-zoom'
                            onClick={() => {
                              popupTagShow(list)
                            }} />

                        </div>
                        :
                        <>
                          <div>
                            <CardVideoPlayer
                              ref={(el) => { videoRefs.current[list.video_id] = el; }}
                              url={playableUrl(list, selectedQuality)}
                              poster={list?.thumbnail_image}
                              playing={props.isAuthenticated && hoveredVideoId === list.video_id}
                              controls={hoveredVideoId === list.video_id}
                              playbackRate={currentPlaybackRate}
                              volume={volume}
                              muted={isMuted}
                              className="object-fit-contain w-100 card-video-img"
                              onVolumeChange={handleVolumeChange}
                              onPlay={() => { if (!props.isAuthenticated) { window.location.href = "/login"; } }}
                              onContextMenu={(event) => event.preventDefault()}
                            />
                          </div>

                          {(hoveredVideoId === list.video_id || activeSettings === list.video_id) && (
                            <>
                              <div className='position-relative'
                                ref={popupRef}
                              >
                                <button
                                  onClick={() => toggleSettings(list.video_id)}
                                  className="settings-btn-qta"
                                >
                                  <IoSettingsSharp className={`active-settings-btn ${activeSettings == list.video_id ? "active" : ''}`} />
                                </button>
                                {activeSettings == list.video_id && (
                                  <div className={`video-control-popup                              
                                  ${speedFlag && quality ? '' : 'active'}`}
                                  >
                                    <div className='show-playback-list'>
                                      <div className="playback-btn"
                                        onClick={() => showQuality()}
                                      >
                                        <MdTune />
                                        Quality
                                        <div className='popup-list-items'>
                                          <span className='popup-list-quality'>({selectedQuality}p)</span>
                                          <MdKeyboardArrowRight />
                                        </div>
                                      </div>
                                      <div className="playback-btn"
                                        onClick={() => showSpeed()}
                                      >
                                        <MdOutlinePlayCircle />
                                        Playback speed
                                        <div className='popup-list-items'>
                                          {currentPlaybackRate}
                                          <MdKeyboardArrowRight />
                                        </div>
                                      </div>
                                      <div className="playback-btn" onClick={() => handlePiP(list.video_id)}>
                                        {pipVideoId === list.video_id
                                          ? <>
                                            <MdCloseFullscreen />
                                            Exit PiP
                                          </>
                                          : <>
                                            <MdPictureInPicture />
                                            Picture-in-Picture
                                          </>
                                        }
                                      </div>
                                    </div>

                                    <div ref={dropdownRef} className={`quality-dropdown-qta ${quality ? '' : 'active'}`}>
                                      <div className='playback-btn palback-back-div'
                                        onClick={() => backToQuality()}
                                      >
                                        <MdKeyboardArrowLeft />
                                        Quality
                                      </div>
                                      {list?.qualityTypeArray?.map((qualityItem) => (
                                        <p key={qualityItem.qualitytype} className="quality-dropdown-p"
                                          onClick={() => handleQualityChange(qualityItem.qualitytype)}>
                                          <input
                                            type="radio"
                                            id={`${list.video_id}-${qualityItem.qualitytype}`}
                                            className="quality-radio-input"
                                            name="global-quality"
                                            value={qualityItem.qualitytype}
                                            checked={selectedQuality === qualityItem.qualitytype}
                                            onChange={() => handleQualityChange(qualityItem.qualitytype)}
                                          />
                                          <label htmlFor={`${list.video_id}-${qualityItem.qualitytype}`}>{qualityItem.qualitytype}</label>
                                        </p>
                                      ))}
                                    </div>

                                    <div className={`show-playback-items ${speedFlag ? '' : 'active'}`}>
                                      <div className='playback-btn palback-back-div'
                                        onClick={() => backToList()}
                                      >
                                        <MdKeyboardArrowLeft />
                                        Playback speed
                                      </div>

                                      {speeds.map((s) => (
                                        <div
                                          key={s.value}
                                          className={`playback-btn ${currentPlaybackRate === s.value ? 'selected' : ''}`}
                                          onClick={() => {
                                            handlePlaybackRateChange(s.value, list.video_id);
                                          }}
                                        >
                                          {s.label}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </>
                      }
                    </div>
                    <div
                      className={`card-body ${viewType === "list" &&
                        ((!props.isAuthenticated) || (props.isAuthenticated && props.userData?.roleDisplayName === "User"))
                        ? "pt-4"
                        : ""
                        }`}
                    >

                      {(props.isAuthenticated) &&
                        <div className="adminIconMain">
                          <div className='adminIconMainLt'>

                            {((props.userData?.roleDisplayName === "Admin" || props.userData?.roleDisplayName === "Super_admin" || props.userData?.roleDisplayName === "User" || props.userData?.roleDisplayName === "APPROVER") && list.approveStatus !== "Rejected") &&
                              <label className="custom-checkbox">
                                <input type="checkbox"
                                  name={list.fileName}
                                  checked={selectedVideoIds.includes(list.video_id)}
                                  onChange={(e) => handleCheckboxChange(e, list.video_id, list.fileTypeId, list)}
                                />
                                <span className="checkmark"></span>
                              </label>
                            }
                          </div>
                          {popupShareStates[index] &&
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }} className='share-icons'
                              ref={shareIconsRef}>
                            </div>
                          }
                          <div className='adminIconMainRt position-relative'>
                            {(props.userData?.roleDisplayName === "Admin" || props.userData?.roleDisplayName === "APPROVER" || props.userData?.roleDisplayName === "Super_admin") &&
                              <>
                                {activeShareIndex === index && (
                                  <div ref={popupRefList} className="icons-popup">
                                    <button className="popupIcon"
                                      onClick={() => {
                                        setVideoIDsIndividual([list.video_id]);
                                        setIsShareLink(true);
                                        if (list.fileType == "Video") {
                                          setHasVideo(true);
                                        } else {
                                          setHasVideo(false);
                                        }
                                        url = newShareLink();
                                      }}>
                                      <FiMail />
                                    </button>
                                    <button className="popupIcon"
                                      onClick={() => linkCopy([list.video_id], "copy", list, index)}>
                                      <FiLink />
                                      {copiedIndex === list.video_id && (
                                        <div
                                          className="position-absolute ms-4 mt-1 px-2 py-1 text-white bg-dark rounded"
                                          style={{ fontSize: "10px", zIndex: 10, width: "53px" }}
                                        >
                                          Copied!
                                        </div>
                                      )}
                                    </button>
                                  </div>
                                )}

                                {list.approveStatus !== "Rejected" && (
                                  <>
                                    {/* While anything is ticked, the selection bar shares instead. */}
                                    {selectedVideoIds.length === 0 && (
                                    <button className="editIcon" aria-label="Share"
                                      onClick={() => {
                                        setVideoIDsIndividual([list.video_id])
                                        setIsShareLink(true)
                                        if (list.fileType == "Video") {
                                          setHasVideo(true)

                                        } else {
                                          setHasVideo(false)
                                        }
                                        // setActiveShareIndex(prev => (prev === index ? null : index))
                                        url = newShareLink()
                                      }}>

                                      <IoShareSocialOutline size={17} />
                                    </button>
                                    )}
                                    <button className="editIcon" onClick={() => listPopup(list, "Edit", index)}>
                                      <FiEdit2 size={17} />
                                    </button>
                                  </>
                                )}
                                <button className="editIcon"
                                  onClick={() => {
                                    setSelectedToDelete(list);
                                    setIsDelete(true)
                                    // deleteList(list)
                                  }}>
                                  <RiDeleteBinLine size={17} />
                                </button>

                                {/* {(!props.isAuthenticated || ((props.isAuthenticated && props.userData.roleDisplayName !== "APPROVER"))) && (
                                  <div className='download-sec'>
                                    <HiDownload className='list-download' size={18} id={`download-btn${index}`} onClick={() => downloadFn(list, index)} />
                                    <div className='icon-download icon-loader' id={`loader-btn${index}`} style={{ display: "none" }}>
                                      <div className="spinner-border text-white" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                    </div>
                                  </div>
                                )} */}
                              </>
                            }
                          </div>
                        </div>
                      }
                      {((viewType === "list") && ((!props.isAuthenticated) || (props.isAuthenticated && props.userData?.roleDisplayName === "User"))) &&
                        <div className='col-md-12 listBtnDiv'>
                          {list.fileType && <span className="listBtnView">
                            {list.fileType == "Video" ? <GrMultimedia /> : <MdOutlinePermMedia />}
                            {list.fileType}
                          </span>}
                          {list.video_date && <span className="listBtnView"><CiCalendarDate />{moment(list.video_date).format('DD-MM-YYYY')}</span>}
                          {list.video_location && <span className="listBtnView"><IoLocationOutline />{list.video_location}</span>}
                          {list.size && <span className="listBtnView"><IoIosResize />{list.size}</span>}
                        </div>
                      }
                      <h5 className="card-title" title={list.video_heading}>{list.video_heading}</h5>
                      <p className="card-text">{list.description}</p>
                    </div>
                  </div>
                </div>
              </div>

            ))}
          </div>
          <div className="d-flex flex-column gap-2 my-4 page-division">
            <div className="d-flex align-items-center justify-content-end flex-wrap gap-3">
              <div className="rows-per-page">
                <span>Rows per page:</span>
                <select value={props.itemsCountPerPage} style={{ minWidth: '60px' }} onChange={(e) => props.setItemsCountPerPage(Number(e.target.value))}>
                  <option value="15">15</option>
                  <option value="30">30</option>
                  <option value="45">45</option>
                  <option value="60">60</option>
                </select>
              </div>
              {totalPages > 1 && (
                <div className="pagination-strip">
                  <button
                    type="button"
                    disabled={!hasPreviousPage}
                    onClick={goToFirstPage}
                  >
                    &lt;&lt; First
                  </button>
                  <button
                    type="button"
                    disabled={!hasPreviousPage}
                    onClick={goToPrevBlock}
                  >
                    &lt;&lt; Previous
                  </button>
                  <span className="pagination-page-info">
                    Page {activePage} of {totalPages}
                  </span>
                  <button
                    type="button"
                    disabled={!hasNextPage}
                    onClick={goToNextBlock}
                  >
                    Next &gt;&gt;
                  </button>
                  <button
                    type="button"
                    disabled={!hasNextPage}
                    onClick={goToLastPage}
                  >
                    Last &gt;&gt;
                  </button>
                </div>
              )}
            </div>
          </div>
          {props.loading && (
            <div className="d-flex flex-column text-center">
              <div>
                <img src={Loader} alt="noData" className="img-fluid" width="100" height="100" />
              </div>
            </div>
          )}
        </div>
      </div>
      <MediaPreview
        open={tagPopupFlag}
        url={selectedData.url}
        fileType={selectedData.file_type_id}
        qualityTypeArray={selectedData.qualityTypeArray}
        poster={selectedData.thumbnail_image}
        onClose={cancelPopup}
        onPlay={() => { if (!props.isAuthenticated) window.location.href = '/login'; }}
      />
      {popupList &&
        <ListUpload userData={props?.userData}
          cancelPopup={cancelPopup} getData={props.getData} getCloudBucketData={props.getCloudBucketData}
          selectData={selectData} mode={mode} selectIndex={selectIndex} />
      }

      {popupReject &&
        <ListReject rejectData={rejectData} userData={props?.userData}
          cancelPopup={cancelPopup} getData={props.getData} />
      }
    </div>
  );
}

export default List;